import { render, staticRenderFns } from "./search-ad-creative-config-form.vue?vue&type=template&id=398b7950&scoped=true"
import script from "./search-ad-creative-config-form.vue?vue&type=script&setup=true&lang=js"
export * from "./search-ad-creative-config-form.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398b7950",
  null
  
)

export default component.exports